import script from "./CardDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CardDetails.vue?vue&type=script&setup=true&lang=js"

import "./CardDetails.vue?vue&type=style&index=0&id=6cf89a35&lang=css"

const __exports__ = script;

export default __exports__